/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, useImperativeHandle, Fragment } from 'react';
import { useSelector } from "react-redux";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { capitalizeFirstLetter, getColumnWidth, idNamingConversion, checkComponentPermission, currencyFormat, getBusinessId } from '../../../../../helpers/utilities';
import { Space, Image } from "antd";
import { Button, Box } from "@mui/material";
import { HeaderView, LinesList, ReportModal } from "./Blocks";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { Link, NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import productActions from "../../../../Product/Product/redux/actions";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { toast } from 'react-toastify';
import { getRequest } from '../../../../../helpers/axiosClient';
import dayjs from 'dayjs';
import moment from 'moment';


export const CustomForm = React.forwardRef((props, ref) => {
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { view, stockId, showDetails, type, clsx, history, dispatch, classes, roleManagement, customerApi, supplierApi } = props;
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails, locationDetails } = useSelector(state => state.productSetupReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const childRef = useRef('');
    const formRef = useRef('');
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [error] = useState({});

    const [form, setForm] = useState({
        createTs: new Date(),
    });
    const [batch, setBatch] = useState([]);
    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState('CREATED');
    const [lines, setLines] = useState([]);
    const [linesSearch, setLinesSearch] = useState([]);
    const [visible, setVisible] = useState('');

    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, []);

    useEffect(() => {
        setLinesSearch(lines);
    }, [lines]);

    const loadTasks = () => {
        locationApi();

        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    };

    const handleSubmit = (e, status = 'CREATED') => {
        e.preventDefault();
        handleCommonSubmit(status);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setLinesSearch(lines);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setLinesSearch(lines?.filter((el) => {
                        const regex = new RegExp(search, "i");
                        return (
                            el?.product?.productName?.match(regex) ||
                            el?.product?.productId?.match(regex) ||
                            el?.unit?.name?.match(regex) ||
                            el?.location?.name?.match(regex) ||
                            String(el?.amount ?? "").match(regex) ||
                            String(el?.pricePerUnit ?? "").match(regex) ||
                            String(el?.quantity ?? "").match(regex)
                        );
                    }));
                }, 500);
            }
        }
    }, [search]);

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let aL = [];

        let lineError = { isValid: true, errors: '' };
        lines?.forEach((element) => {
            if (element.quantity === '' || element.quantity == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} quantity field can't be blank` };
            }
            if (element.locationId === '' || element.locationId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} location field can't be blank` };
            }
            if (element.unitId === '' || element.unitId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} unit field can't be blank` };
            }
            if (element?.batchOverride && !element?.batchDetails) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Please enter Batch Details` }
            }
            if (element?.batchDetails && element?.batchDetails?.length > 0) {
                let batchQuantity = element?.batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
                if (batchQuantity !== parseFloat(element?.quantity)) {
                    lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Total Batch quantity should equal Line Quantity` }
                }
            }
        });
        if (lineError?.isValid) {
            form.transactionDate = form.transactionDate ? moment(form.transactionDate).format("YYYY-MM-DDT00:00:00.000+00:00") : moment().format("YYYY-MM-DDT00:00:00.000+00:00");
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return aL.push({ ...element })
            });

            if (callDispatch) {
                form.adjustmentStatus = status || null;
                let subForm = { ...form };
                aL && aL.length > 0 && aL.map((element, i) => {
                    delete element.location; delete element.orderDetails; delete element.orderLineDetails;
                    delete element.product;
                    delete element.unit;
                    aL.splice(i, 1, element);
                });
                subForm.stockAdjustmentItems = aL;
                subForm.serviceType = subForm?.serviceType || '';
                subForm.customerId = subForm?.customerId || null;
                subForm.unitId = subForm?.unitId || null;
                subForm.supplierId = subForm?.supplierId || null;
                delete subForm.createTs; delete subForm.updateTs; delete subForm.unit; delete subForm.customer; delete subForm.supplier; delete subForm.updatedBy; delete subForm.createdBy; delete subForm.business;
                dispatch({
                    type: subForm?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                    url: 'stockAdjustment',
                    title: 'Adjust Stock',
                    id: subForm?.id,
                    details: subForm
                });
            } else {
                return form
            }
        } else {
            if (lineError?.errors) {
                toast.dismiss();
                toast.error(lineError?.errors);
            }
        }
    }

    const customObject = (details, id) => {
        let a = details && details?.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const deleteLine = async (index) => {
        // Find the line at the given index
        const line = lines[index];
        if (!line) return;

        try {
            // If the line exists in DB (has an id), call backend API
            if (line.id) {
                await dispatch({
                    type: crudActions.DELETE_DETAILS_START,
                    url: `stockAdjustmentLines/delete`,  // use RESTful route
                    id: line?.id,                // ensure DELETE request
                    title: 'Stock Adjustmnet Line',
                });
            }

            // Remove from local state
            const updatedLines = lines.filter((_, i) => i !== index);
            setLines(updatedLines);

        } catch (error) {
            console.error('Error deleting line:', error);
            toast.error('Failed to delete line. Please try again.');
        }
    };


    const handleBulkDelete = (selected) => {
        setLines((prevLines) => prevLines.filter(
            (line) => !selected.includes(line.lineNumber)
        ));
        let ids = lines.filter(line => selected.includes(line.lineNumber) && line?.id).map(line => line.id);
        if (ids?.length > 0) {
            dispatch({
                type: crudActions.DELETE_DETAILS_START,
                url: 'stockAdjustmentLines/deleteByIds',
                title: 'Stock Adjustment Lines',
                details: ids
            });
        }
        formRef.current.handleSelected([]);
    };

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                lines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            setConfirm(false);
            setStatus(form.adjustmentStatus);
            history.push(`/product/inventory/adjust-stock/${AESEncrypt(createData.id)}/view`, `create`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            //setCommonError(error);
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setConfirm(false);
            setStatus(form.adjustmentStatus);
            history.push(`/product/inventory/adjust-stock/${AESEncrypt(stockId)}/view`, `${type}`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            let text = editError.error.message;
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);


    const createProduct = async (filterForm) => {
        let filter = { order: 'id desc' };

        if (filterForm.productId) {
            filter = { where: { and: [{ id: filterForm.productId }] }, order: 'id desc' };
        } else if (filterForm.groupId) {
            filter = { where: { and: [{ productGroupId: filterForm.groupId }] }, order: 'id desc' };
        }

        try {
            const uResponse = await getRequest(`${process.env.REACT_APP_API_URL}/client-products/?filter=${encodeURIComponent(JSON.stringify(filter))}`);

            const uData = uResponse.data;
            if (!uData?.length) return;

            let lineNumber = (lines?.length ?? 0) + 1;

            let defaultLocation;
            if (locationDetails?.length) {
                defaultLocation =
                    locationDetails.find(el => el.default) || locationDetails[0];
            }

            const updatedData = await Promise.all(
                uData.map(async el => {
                    const units = await formRef.current.handleUnits(el);
                    let unit = el.salesUnit || null;
                    let unitId = el.salesUnitId || null;

                    if (units?.find(u => u.id === form?.unitId)) {
                        unit = form?.unit;
                        unitId = form?.unitId;
                    }

                    return {
                        product: el,
                        productId: el.id,
                        quantity: 1,
                        pricePerUnit: el?.costPrice || 0,
                        amount: el?.costPrice || 0,
                        unitId,
                        unit,
                        locationId: defaultLocation?.id ?? null,
                        location: defaultLocation,
                        lineNumber: lineNumber++,
                        batchOverride: el.batchActivation,
                        mrp: el.mrp
                    };
                })
            );

            setLines(prev => [...prev, ...updatedData]);
            formRef.current.handleFilterForm();

        } catch (error) {
            console.error("Error fetching data", error);
        }
    };


    const chunkArray = (arr, size) => {
        let chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };

    // Builds the batchDetails entry for an imported row and folds it into whatever the line already
    // carries. The shape matches what LinesList's handleLineSubmit produces for a hand-entered batch,
    // so both reach the API identically. A row carries a single batch whose quantity is the row
    // quantity, so repeat rows for one product accumulate batch by batch and the batch total stays
    // equal to the merged line quantity.
    const buildBatchDetails = (existingBatch, row, { pricePerUnit, unitId, productId, mrp }) => {
        const details = [...(existingBatch || [])];
        if (!row.batchNumber) return details;

        const quantity = parseFloat(row.quantity) || 0;
        const price = parseFloat(pricePerUnit) || 0;
        const index = details.findIndex(b => b?.batchNumber === row.batchNumber);

        if (index >= 0) {
            const mergedQuantity = (parseFloat(details[index]?.purchaseQuantity) || 0) + quantity;
            details[index] = {
                ...details[index],
                purchaseQuantity: mergedQuantity,
                purchasePrice: (mergedQuantity * price) - (parseFloat(details[index]?.discountAmount) || 0),
            };
            return details;
        }

        details.push({
            batchNumber: row.batchNumber,
            purchaseQuantity: quantity,
            // Same defaults addBatch() applies when a batch row is added by hand.
            manufacturingDate: parameterDetails?.batchMfgDate ? new Date() : null,
            expiryDate: parameterDetails?.batchExpiryDate ? new Date() : null,
            useByDate: parameterDetails?.batchBestBeforeDate ? new Date() : null,
            mrp: parseFloat(mrp || 0),
            perUnitPrice: price,
            purchasePrice: quantity * price,
            unitId,
            businessId: getBusinessId(),
            productId,
        });
        return details;
    };

    // Consumes rows already structurally validated by the ImportLines drawer (Blocks/ImportLines.js) -
    // required fields present, quantity numeric and non-zero. Here we resolve products/units/locations,
    // merge duplicate products into their existing line, and append the rest - modelled on createProduct
    // above, which does this same shape of work for the Run Product Query flow.
    const importLines = async (rows, importType = 'update') => {
        if (!rows?.length) return null;

        const productIds = [...new Set(rows.map(r => r.productId))];
        let products = [];

        try {
            // Chunk product IDs to stay under URL length limits on the filter querystring.
            const responses = await Promise.all(
                chunkArray(productIds, 200).map((ids) => {
                    const filter = { where: { and: [{ status: 'ACTIVE' }, { productId: { inq: ids } }] } };
                    return getRequest(`${process.env.REACT_APP_API_URL}/client-products/?filter=${encodeURIComponent(JSON.stringify(filter))}`);
                })
            );
            responses.forEach(res => {
                if (res?.data?.length) products = products.concat(res.data);
            });
        } catch (error) {
            console.error("Error fetching products for import", error);
            const message = error?.response?.data?.error?.message || error?.message || 'Please try again.';
            toast.dismiss();
            toast.error('Failed to fetch products for import.');
            return { imported: 0, merged: 0, skipped: rows.length, notFound: [], batchPending: 0, error: `Could not load products: ${message}` };
        }

        const productByCode = {};
        products.forEach(p => { productByCode[p.productId] = p; });

        let defaultLocation;
        if (locationDetails?.length) {
            // Note: locationApi() below only loads the first 50 locations (limit: 50). Tenants with
            // more locations than that may fall back to the default here even when the sheet names
            // a real but unloaded location.
            defaultLocation = locationDetails.find(el => el.default) || locationDetails[0];
        }

        // lineNumber must be computed off the real `lines` array, not the filtered linesSearch that
        // LinesList receives as its `lines` prop - numbering off a filtered list would be wrong.
        let lineNumber = (lines?.length ?? 0) + 1;
        const notFoundIds = [];
        let mergedCount = 0;
        let skippedCount = 0;
        const importedProducts = [];
        const workingLines = [...lines];

        for (const row of rows) {
            const product = productByCode[row.productId];
            if (!product) {
                notFoundIds.push(row.productId);
                continue;
            }

            let unit = product.salesUnit || null;
            let unitId = product.salesUnitId || null;

            if (parameterDetails?.inventoryTransaction) {
                // handleUnits hits two endpoints without guarding either - a failure there must not
                // take the whole import down, so fall back to the product's own sales unit.
                let units = [];
                try {
                    units = await formRef.current.handleUnits(product);
                } catch (error) {
                    console.error("Error resolving units for import", error);
                }
                const matchedUnit = row.unitName && units?.find(u => u?.name?.toLowerCase() === row.unitName.toLowerCase());
                if (matchedUnit) {
                    unit = matchedUnit;
                    unitId = matchedUnit.id;
                }
            } else if (row.unitName && unitMesurementdetails?.length) {
                const matchedUnit = unitMesurementdetails.find(u => u?.name?.toLowerCase() === row.unitName.toLowerCase());
                if (matchedUnit) {
                    unit = matchedUnit;
                    unitId = matchedUnit.id;
                }
            }

            let location = defaultLocation;
            if (row.locationName && locationDetails?.length) {
                const matchedLocation = locationDetails.find(l => l?.name?.toLowerCase() === row.locationName.toLowerCase());
                if (matchedLocation) location = matchedLocation;
            }

            const pricePerUnit = row.pricePerUnit != null && !isNaN(row.pricePerUnit) ? row.pricePerUnit : (product?.costPrice || 0);
            const mrp = row.mrp != null && !isNaN(row.mrp) ? row.mrp : product?.mrp;

            // The sheet's Batch Applicable column wins when filled in - it is the same override the
            // line drawer exposes as its "Batch Applicable" checkbox - otherwise the product's own
            // batchActivation stays the default.
            const batchOverride = row.batchOverride != null ? row.batchOverride : !!product?.batchActivation;

            const existingIndex = workingLines.findIndex(l => l.productId === product.id);
            if (existingIndex >= 0 && importType === 'insert') {
                // "Insert Only New Products" - this product already has a line, leave it untouched.
                skippedCount++;
                continue;
            }

            if (existingIndex >= 0) {
                // Duplicate product (already on the form, or a repeat row in this sheet) - merge
                // quantities into the existing line instead of appending a second row, since
                // changeHandlerLine matches rows by productId and would otherwise edit both in lockstep.
                const existing = workingLines[existingIndex];
                const mergedQuantity = (parseFloat(existing.quantity) || 0) + row.quantity;
                const existingPrice = existing.pricePerUnit || 0;
                const mergedBatch = buildBatchDetails(existing.batchDetails, row, {
                    pricePerUnit: existingPrice,
                    unitId: existing.unitId,
                    productId: product.id,
                    mrp: existing.mrp,
                });
                workingLines[existingIndex] = {
                    ...existing,
                    quantity: mergedQuantity,
                    amount: mergedQuantity * existingPrice,
                    batchOverride: existing.batchOverride || batchOverride,
                };
                // Only attach batchDetails when there is a batch to record - handleCommonSubmit treats
                // an empty array as "batch details supplied", so a batch-applicable line with no
                // batches must keep the key absent to stay blocked on save.
                if (mergedBatch.length) workingLines[existingIndex].batchDetails = mergedBatch;
                mergedCount++;
            } else {
                const batchDetails = buildBatchDetails([], row, { pricePerUnit, unitId, productId: product.id, mrp });
                const newLine = {
                    product,
                    productId: product.id,
                    quantity: row.quantity,
                    pricePerUnit,
                    amount: row.quantity * pricePerUnit,
                    unitId,
                    unit,
                    locationId: location?.id ?? null,
                    location,
                    lineNumber: lineNumber++,
                    batchOverride,
                    mrp
                };
                if (batchDetails.length) newLine.batchDetails = batchDetails;
                workingLines.push(newLine);
                importedProducts.push(product);
            }
        }

        setLines(workingLines);

        if (importedProducts.length) {
            // Mirrors onEdit's use of handleBulkUnits - populates the grid's per-product Unit
            // dropdown state; skipping it would leave the Unit column blank for imported rows.
            setTimeout(() => {
                formRef.current.handleBulkUnits(importedProducts);
            });
        }

        // A batch-applicable line with no batch rows, or whose batch quantities do not add up to the
        // line quantity, is blocked by handleCommonSubmit on save - surface it now rather than letting
        // the user find out at submit time.
        const batchPending = workingLines.filter(l => {
            if (!l?.batchOverride) return false;
            if (!l?.batchDetails?.length) return true;
            const total = l.batchDetails.reduce((a, v) => a + (parseFloat(v?.purchaseQuantity) || 0), 0);
            return total !== parseFloat(l.quantity);
        }).length;

        const importedCount = importedProducts.length + mergedCount;
        const skipped = notFoundIds.length + skippedCount;
        let message = `${importedCount} line${importedCount === 1 ? '' : 's'} imported, ${skipped} skipped`;
        if (mergedCount > 0) {
            message += `, ${mergedCount} merged into existing line${mergedCount === 1 ? '' : 's'}`;
        }
        if (batchPending > 0) {
            message += `, ${batchPending} line${batchPending === 1 ? '' : 's'} need batch details`;
        }
        toast.dismiss();
        toast[skipped > 0 ? 'warning' : 'success'](message);

        // Handed back so the drawer can stay open and show exactly what was rejected when nothing
        // landed - a transient toast is not enough to debug a sheet against.
        return {
            imported: importedProducts.length,
            merged: mergedCount,
            skipped,
            notFound: notFoundIds,
            batchPending,
            message
        };
    };

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            setForm({ ...data, transactionDate: data?.transactionDate ? dayjs(data?.transactionDate).$d : null, });
            setStatus(data?.adjustmentStatus);
            if (data?.stockAdjustmentItems) {
                setLines(data?.stockAdjustmentItems);
                setTimeout(() => {
                    const products = data?.stockAdjustmentItems?.map(el => el?.product).filter(Boolean); // remove null/undefined
                    // Call handleBulkUnits once for all products
                    formRef.current.handleBulkUnits(products);
                })
            }
        }
    }))

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const productGroupApi = () => {
        dispatch({
            type: productSetupActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups',
            filter: {
                order: 'id desc'
            },
        });
    }

    const calculateLineTotal = (el) => {
        return {
            ...el,
            amount: (el?.quantity || 0) * (el?.pricePerUnit || 0),
        };
    };

    const changeHandlerLine = (data, e, name = '', relation = '') => {
        const newTodos = lines.map((el) => {
            if (el.productId === data.productId) {
                if (relation !== '') {
                    const d = { ...el, [name]: e.id, [relation]: e };
                    return calculateLineTotal(d);
                } else {
                    const d = { ...el, [name]: e };
                    return calculateLineTotal(d);
                }
            }
            return el; // ✅ keep other rows unchanged
        });

        setLines(newTodos);
    };

    const handleConfirmSubmit = (e) => {
        e.preventDefault();
        let data = handleCommonSubmit('CONFIRMED', false);
        if (data) {
            setConfirm(true);
        }
    }

    const addBatch = () => {
        setBatch((prevState) => {
            return [...prevState, { batchNumber: '', purchaseQuantity: 1, manufacturingDate: parameterDetails?.batchMfgDate ? new Date() : null, expiryDate: parameterDetails?.batchExpiryDate ? new Date() : null, useByDate: parameterDetails?.batchBestBeforeDate ? new Date() : null }];
        });
    }

    const changeHandlerBatch = (e, name, i) => {
        // Create a shallow copy of the array
        const updatedArr = [...batch];

        // Update the specific element immutably
        updatedArr[i] = {
            ...updatedArr[i],
            [name]: e,
        };

        // Update state with the new array
        setBatch(updatedArr);
    };

    const onDeletBatch = (data) => {
        let selectedSIngleIndex = batch?.findIndex(el => el.batchNumber === data.batchNumber);
        if (selectedSIngleIndex >= 0) {
            setBatch(prevState => {
                return prevState.filter((value, i) => i !== selectedSIngleIndex)
            });
            // setErrorBatchQuantity(false);
        }
        return false;
    }


    return (
        <Fragment>
            <CustomAccordion
                title={`${capitalizeFirstLetter(type)} Adjust Stock`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={clsx(classes.tabWrapSubmit)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Adjust Stock', 'Ellipsis Action', 'View Document') &&
                                            <NavLink to="#" onClick={() => setVisible(!visible)} tabIndex={-1}>
                                                <Image tabIndex={-1} className={""} src={ViewIcon} wrapperStyle={{ lineHeight: 1, marginRight: 5 }} preview={false} />
                                                <span className={classes.customerInvoiceNone}>View Document</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Adjust Stock', 'Page', 'Confirm') && status === 'CREATED' &&
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'adjustStock', 'Button')}
                                                onClick={(e) => handleConfirmSubmit(e)}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader }, { [classes.disabled]: lines.length === 0 })}
                                            >Confirm</Button>
                                        }
                                        {
                                            status === 'CREATED' && <>
                                                {
                                                    (type === 'edit' || type === 'create') ? <Button
                                                        tabIndex={-1}
                                                        key="Save"
                                                        type="submit"
                                                        color="primary"
                                                        variant="contained"
                                                        id={idNamingConversion('Save', 'adjustStock', 'Button')}
                                                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader })}
                                                    >{type === 'create' ? 'Save' : 'Update'}</Button> : <Link
                                                        to={`/product/inventory/adjust-stock/${AESEncrypt(stockId)}/edit`}
                                                        id={idNamingConversion('Edit', 'adjustStock', 'Link')}
                                                        className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0, { [classes.loadingA]: editLoader || createLoader })}>Edit</Link>
                                                }
                                            </>
                                        }
                                    </Space>
                                </div>
                                <div className={classes.tabDesign}>
                                    <HeaderView {...props}
                                        form={form}
                                        view={view}
                                        status={status}
                                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                        idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                        customObject={(details, id) => customObject(details, id)}
                                        customerDetails={customerDetails}
                                        supplierDetails={supplierDetails}
                                        customerApi={(s) => customerApi(s)}
                                        supplierApi={(s) => supplierApi(s)}
                                        error={error}
                                        lines={lines}
                                        unitMesurementdetails={unitMesurementdetails}
                                        changeHandler={(data, name, relation = '') => {
                                            if (relation) {
                                                setForm({
                                                    ...form, [relation]: data, [name]: data.id
                                                })
                                            } else {
                                                let d = {
                                                    ...form, [name]: data
                                                };
                                                if (name === 'enableServices') {
                                                    if (data) {
                                                        d['serviceType'] = 'SERVICE BILL';
                                                    } else {
                                                        d['serviceType'] = '';
                                                        d['customerId'] = '';
                                                        d['supplierId'] = '';
                                                    }
                                                    childRef?.current?.handleAdjustHeight();
                                                }
                                                if (name === 'serviceType') {
                                                    d['customerId'] = null;
                                                    d['supplierId'] = null;
                                                }
                                                setForm(d)
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Adjust Stock Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter
                            } >
                                <div className={classes.loadMoreCircle}></div>
                            </div > : <LinesList
                                classes={classes}
                                locationApi={(s) => locationApi(s)}
                                form={form}
                                ref={formRef}
                                type={type}
                                useEventListener={useEventListener}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                clsx={clsx}
                                lines={linesSearch}
                                dispatch={dispatch}
                                customObject={(details, id) => customObject(details, id)}
                                productApi={(s = '', id = '') => productApi(s, id)}
                                productGroupApi={() => productGroupApi()}
                                productActions={productActions}
                                productGroupDetails={productGroupDetails}
                                myProductdetails={myProductdetails}
                                businessDetails={businessDetails}
                                unitMesurementdetails={unitMesurementdetails}
                                getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                deleteLine={(id) => deleteLine(id)}
                                lineSubmit={(data, id) => lineSubmit(data, id)}
                                headerView={view}
                                view={view}
                                currencyFormat={(amount) => currencyFormat(amount)}
                                parameterDetails={parameterDetails}
                                roleManagement={roleManagement}
                                locationDetails={locationDetails}
                                changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                search={search}
                                setSearch={(s) => setSearch(s)}
                                createProduct={(data) => createProduct(data)}
                                importLines={(rows, importType) => importLines(rows, importType)}
                                handleBulkDelete={(selected) => handleBulkDelete(selected)}
                                batch={batch}
                                setLines={(d) => setLines(d)}
                                addBatch={() => addBatch()}
                                setBatch={(d) => setBatch(d)}
                                changeHandlerBatch={(e, name, i) => changeHandlerBatch(e, name, i)}
                                onDeletBatch={(d) => onDeletBatch(d)}
                            />
                        }
                    </>
                }
            />
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Adjust Stock Confirmation'}
                loading={createLoader || editLoader}
                onOpen={() => handleCommonSubmit('CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={< p > Are you sure do you want to Confirm the Adjust Stock ?</p >}
            />
            <ReportModal
                open={visible}
                details={{
                    ...form,
                    stockAdjustmentItems: lines
                }}
                handleClose={() => setVisible(!visible)}
            />
        </Fragment>
    )
})